import {Box, styled} from "@mui/material";

type AccessDeniedProps = {
  imagetranslate: string;
  imagewidhtonsmallscreens: string;
  imagemargintop: string;
};

const StyledBox = styled(Box)<AccessDeniedProps>(
  ({theme, imagetranslate, imagemargintop, imagewidhtonsmallscreens}) => `
position: relative;
.accessDenied {
    &__dots {
       position: absolute;

       ${theme.breakpoints.up(1550)} {
            transform: translate(-40.5%);
        } 

       ${theme.breakpoints.down(1550)} {
            width: 534.4px;
            height: auto;
            transform: translate(-50.5%);
       
        } 
    }

    &__textArea {
        position: absolute;
        height: 100vh;
        width: 50%;
        display: flex;
        align-items: center;
        margin-left: 17px;

        &--chip {
            color: ${theme.palette.primary[700]};
            background-color: ${theme.palette.primary[50]};
        }

        &--title {
            margin-top: 12px;
        }

        &--body {
            margin-top: 4px;
        }
        
        &--action {
            margin-top: 32px;
            display: flex;
            gap: 24px;
            z-index: 1;
        }

    }

    &__imageContainer {
        position: absolute;
        right: -24px;
        width: auto;
          
       &--image {
        height: auto;
        float: right;
        transform: translate(${imagetranslate});
        margin-top: ${imagemargintop};
        transition: 1000ms ease-in-out;

            ${theme.breakpoints.down(1300)} {
                width: 70%;
                margin-top: 75px;
            } 

           ${theme.breakpoints.between(1250, 1600)} {
                width: ${imagewidhtonsmallscreens};
            }  

            ${theme.breakpoints.up(1550)} {
                width: 100%;
            }    
       }
    }

}
`,
);

export default StyledBox;
